import React, { ReactElement, forwardRef } from "react";

import { Flex, FlexProps } from "@chakra-ui/react";

type SwipeScrollWrapperProps = {
  mainComponent: ReactElement<
    Pick<FlexProps, "flex" | "scrollSnapAlign" | "scrollSnapStop"> & {
      "data-swipe-scroll-id"?: string;
    }
  >;
  actionsLeft?: ReactElement<Pick<FlexProps, "scrollSnapAlign">>;
  actionsRight?: ReactElement<Pick<FlexProps, "scrollSnapAlign">>;
  showActionsLeft?: boolean;
  showActionsRight?: boolean;
  handleSwipeScroll: (event: React.UIEvent<HTMLDivElement, UIEvent>) => void;
  flex?: string;
};

export const SwipeScrollWrapper = forwardRef<HTMLDivElement, SwipeScrollWrapperProps>(
  (
    {
      mainComponent,
      actionsLeft,
      actionsRight,
      showActionsLeft,
      showActionsRight,
      handleSwipeScroll,
      ...rest
    },
    ref,
  ) => {
    return (
      <Flex
        ref={ref}
        w="100%"
        flexWrap="nowrap"
        overflowX={showActionsLeft || showActionsRight ? "scroll" : undefined}
        scrollSnapType="x mandatory"
        css={{
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
        onScroll={handleSwipeScroll}
        {...rest}
      >
        {actionsLeft &&
          showActionsLeft &&
          React.cloneElement(actionsLeft, { scrollSnapAlign: "start" })}
        {React.cloneElement(mainComponent, {
          flex: "0 0 100%",
          scrollSnapAlign: "center",
          scrollSnapStop: "always",
          "data-swipe-scroll-id": "main-component",
        })}
        {actionsRight &&
          showActionsRight &&
          React.cloneElement(actionsRight, { scrollSnapAlign: "end" })}
      </Flex>
    );
  },
);
